import { z } from 'zod';
export const insuranceClaimsDocumentsNoticeArtifactCapability = 'documents.insurance-claim-notice-artifact.v1';
export const insuranceClaimsDocumentsNoticeArtifactSlot = 'insurance-claims.notice-artifact';
export const insuranceClaimsDocumentsNoticeArtifactProviderId = 'documents.server.insurance-claims-notice-artifact';
const idSchema = z.string().uuid();
const sha256Schema = z.string().regex(/^[a-f0-9]{64}$/);
const documentStatusSchema = z.enum([
    'draft', 'sent', 'viewed', 'signed', 'declined', 'voided', 'expired',
]);
export const insuranceClaimsDocumentsNoticeArtifactProviderRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(insuranceClaimsDocumentsNoticeArtifactCapability),
    resourceType: z.literal('insurance-claims.aob-notice'),
    resourceId: idSchema,
    projectId: idSchema,
});
const signatureSchema = z.discriminatedUnion('state', [
    z.strictObject({ state: z.literal('missing') }),
    z.strictObject({
        state: z.literal('present'),
        signatureId: idSchema,
        signatureSha256: sha256Schema,
        signedAt: z.string().datetime({ offset: true }),
    }),
]);
const finalArtifactSchema = z.discriminatedUnion('state', [
    z.strictObject({ state: z.literal('missing') }),
    z.strictObject({
        state: z.literal('present'),
        objectId: idSchema,
        contentType: z.string().trim().min(1).max(255),
        sizeBytes: z.number().int().positive().safe(),
        sha256: sha256Schema,
        verifiedAt: z.string().datetime({ offset: true }),
        attachedAt: z.string().datetime({ offset: true }),
    }),
]);
export const insuranceClaimsDocumentsNoticeArtifactFactSchema = z.strictObject({
    capability: z.literal(insuranceClaimsDocumentsNoticeArtifactCapability),
    noticeId: idSchema,
    instanceId: idSchema,
    sourceVersion: z.number().int().positive(),
    contentHash: sha256Schema,
    status: documentStatusSchema,
    signature: signatureSchema,
    artifact: finalArtifactSchema,
    observedAt: z.string().datetime({ offset: true }),
});
export const insuranceClaimsDocumentsNoticeArtifactProviderResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(insuranceClaimsDocumentsNoticeArtifactCapability),
    noticeId: idSchema,
    facts: z.array(insuranceClaimsDocumentsNoticeArtifactFactSchema).max(500),
}).superRefine((value, context) => {
    const instanceIds = value.facts.map(({ instanceId }) => instanceId);
    if (new Set(instanceIds).size !== instanceIds.length) {
        context.addIssue({ code: 'custom', path: ['facts'], message: 'Document facts must be unique.' });
    }
    value.facts.forEach((fact, index) => {
        if (fact.noticeId !== value.noticeId) {
            context.addIssue({
                code: 'custom', path: ['facts', index, 'noticeId'],
                message: 'Document facts must belong to the requested notice.',
            });
        }
    });
});
export const insuranceClaimsNoticeOwnerFactUnavailableReasonSchema = z.enum([
    'not-installed',
    'not-enabled',
    'permission-denied',
    'provider-invalid',
    'provider-failed',
]);
export const insuranceClaimsDocumentsNoticeArtifactAvailabilitySchema = z.discriminatedUnion('state', [
    insuranceClaimsDocumentsNoticeArtifactProviderResponseSchema,
    z.strictObject({
        state: z.literal('unavailable'),
        capability: z.literal(insuranceClaimsDocumentsNoticeArtifactCapability),
        reasonCode: insuranceClaimsNoticeOwnerFactUnavailableReasonSchema,
    }),
]);
//# sourceMappingURL=insurance-claims-documents-notice-artifact.contract.js.map